import { rateFor } from './pricingModel';

const money = (value) =>
  `$${Math.round(value).toLocaleString('en-US')}`;

const rangeText = (low, high) =>
  low === high
    ? money(low)
    : `${money(low)}–${money(high)}`;

export function experiencePriceLabel(experience) {
  if (!experience) {
    return 'Pricing on request';
  }

  // The self-serve pricing model currently covers Denver. Keep Casper
  // transparent rather than showing an imprecise $, $$, or $$$ tier.
  if (experience.city !== 'Denver') {
    return 'Pricing on request';
  }

  const rate = rateFor(experience);

  if (
    !rate ||
    rate.low == null ||
    rate.high == null
  ) {
    return 'Pricing on request';
  }

  if (rate.low === 0 && rate.high === 0) {
    return rate.confidence === 'published'
      ? 'Free'
      : 'Est. free';
  }

  const amount = rangeText(rate.low, rate.high);
  const prefix =
    rate.confidence === 'published' ? '' : 'Est. ';

  if (rate.basis === 'per_person') {
    return `${prefix}${amount}/person`;
  }

  if (rate.basis === 'per_unit') {
    return `${prefix}${amount}/${rate.unitLabel || 'unit'}`;
  }

  return `${prefix}${amount} total`;
}
